import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import { PrivateRoute } from '../../../utils/route-auth';
import { PERMISSION } from '../../../constants/permission';

import asyncRoute from '../../../helpers/hoc/asyncRoute';
import routes from '../../../routes';
import { connect } from 'react-redux';
import _, { isEmpty, get, cloneDeep } from 'lodash';
import { withRouter } from "react-router-dom";
import { isTenantAdvertiser, isTenantAgency } from '../../../selectors/index';

const List = asyncRoute(() => import('./List'));
const Add = asyncRoute(() => import('./Add'));
const ViewAccount = asyncRoute(() => import('./ViewAccount'));

class Tenant extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAdvertiser: false,
      isAgency: false
    }
  }

  async componentWillMount() {
    // console.log(this.props.tenantId);
    let isTenantAdv = isTenantAdvertiser(this.props.tenantId);
    let isAgency = isTenantAgency(this.props.tenantId);
    this.setState({ isAdvertiser: isTenantAdv, isAgency });
  }

  render() {

    const { isAdvertiser, isAgency} = this.state;

    return (
      <Switch>
        <Route exact path={`${this.props.match.path}`} render={() => <List />} />
        {/* <Route path={`${props.match.path}/${routes.admin.tenant.add}`} component={Add} />
    <Route path={`${props.match.path}/${routes.admin.tenant.edit}/:id`} component={Add} /> */}
        {
          isAgency &&
          <PrivateRoute path={`${this.props.match.path}/${routes.admin.account.add}`} component={Add}
            permissions={[PERMISSION.ADMIN.PROFILE.ADD]}
            defaultRoute={'admin'} />
        }

        {
          isAgency &&
          <PrivateRoute path={`${this.props.match.path}/${routes.admin.account.edit}`} component={Add}
            permissions={[PERMISSION.ADMIN.PROFILE.EDIT]}
            defaultRoute={'admin'} />
        }

        {
          isAgency &&
          <PrivateRoute path={`${this.props.match.path}/${routes.admin.account.view}/:id`}
            permissions={[PERMISSION.ADMIN.PROFILE.VIEW]}
            component={ViewAccount} defaultRoute={'admin'} 
          />
        }

      </Switch>
    )
  }
}

export default withRouter(connect(
  (state) => ({
    tenantId: get(state, 'app.preSignInState.tenantId', '')
  })
)(Tenant));

